// Material UI
import { makeStyles } from '@material-ui/core'
import Colors from '../../../constants/Colors'

export default makeStyles({
  flag: {
    width: 32,
    gridArea: 'flag',
  },
  prefixNumber: {
    gridArea: 'prefix',
    fontSize: 16,
    fontWeight: 100,
  },
  root: {
    gridGap: 8,
    display: 'grid',
    placeContent: 'center',
    borderRadius: 8,
    padding: 16,
    border: `1px solid ${Colors.DISABLED_COLOR}`,
    gridTemplateAreas: `"flag prefix"`,
    cursor: 'not-allowed',
  },
})
